import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { heightDirective } from '../../../../shared/directives/height.directive';
import { CartPaymentMethods } from '../../core/enums/CartPaymentMethods';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';

@Component({
  selector: 'app-payment-button',
  standalone: true,
  imports: [
    heightDirective,
    TranslatePipe
  ],
  templateUrl: './payment-button.component.html',
  styleUrl: './payment-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'd-contents'
  }
})
export class PaymentButtonComponent extends BaseComponent {

  @Input({ required: true }) disabled: boolean;
  @Input({ required: true }) type: CartPaymentMethods;
  @Input({ required: true }) icon: string;
  @Input() theme: 'blue' | 'green' = 'blue';

  @Output() paymentClick = new EventEmitter<CartPaymentMethods>();
}
